module.exports = __webpack_public_path__ + "img/referral-dark.24a3d931.png";